'use strict';

import availUnitsHtmlUrl from './views/googleAdManagerAvailUnit.html';
var app = angular.module('app.googleAdManagerAvailUnits.component', []);

app.component('googleAdManagerAvailUnits', {
    bindings: {
        showActions: '<',
        orderId : '=',
        model: '=',
        selectedAvailUnits: '='
    },
    templateUrl: availUnitsHtmlUrl,
    controller: function ($scope,FormService,$ioAlert) {
        var self = this;
        self.matchedUnits = null;
        self.availableUnits = null;
        self.unit_message = null;

        self.getAvailUnits = function(formData) {
            console.log($scope);
            formData['order_id']=self.orderId.id;
            formData['operation']='inventory';
            FormService.validateGamAvailUnits(formData).then(function (data) {
                if (data.data.http_status!==200) {
                  console.log(data);
                    self.matchedUnits = null;
                    self.availableUnits = null;
                    self.unit_message = null;
                    self.error_message=data.data.message;
                } else {
                    self.matchedUnits = data.data.matched_units;
                    self.availableUnits = data.data.available_units;
                    self.unit_message = data.data.unit_message;
                    self.error_message=null;
                }

            }, function (error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        };
    }
});